import axios from "axios";
import { toast } from "react-toastify";

const _axios = axios.create();

let sessionExpiredShown = false;

// Global response interceptor — catches 401 (Redis session expired) on any API call
_axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      if (!sessionExpiredShown) {
        sessionExpiredShown = true;
        toast.error(
          "Your session has been idle for more than 60 minutes. Please re-login to continue.",
          {
            toastId: "session-expired",
            autoClose: 4000,
            onClose: () => {
              localStorage.clear();
              window.location.href = "/login";
            }
          }
        );
        // Fallback redirect in case toast is dismissed or blocked
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/login";
        }, 4500);
      }
    }
    return Promise.reject(error);
  }
);

export class Http {
  static get(url, options = {}) {
    console.log("url--> ", url);
    return _axios.get(url, options);
  }

  static post(url, body, options = {}) {
    return _axios.post(url, body, options);
  }

  static put(url, body, options = {}) {
    return _axios.put(url, body, options);
  }

  static delete(url, body, options = {}) {
    return _axios.delete(url, body, options);
  }

  static getAuthToken() {
    return {
      headers: {
        'x-access-token': localStorage.getItem('authToken')
      }
    }
  }
}
